module.exports = __webpack_public_path__ + "static/media/img2.5dd0d440.jpeg";